import { backendApi } from './requests';

/**
 * Форма зворотного зв'язку.
 *
 * Раніше повідомлення йшло прямо в Telegram API з фронтенда (api/bot.js),
 * і токен бота лежав у REACT_APP_TELEGRAM_BOT_API — змінні REACT_APP_*
 * підставляються в публічний JS-бандл під час збірки, тож токен був видимий
 * будь-кому в інструментах розробника браузера. Тепер фронтенд шле лише текст
 * форми на бекенд, а той сам пересилає його в Telegram — токен лишається
 * в backend/.env.
 */
export const sendFeedbackFetch = (data) => backendApi.post('/feedback', data);
